// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {FormattedProperty, PropertyRenderType} from 'common/util/format-property';
import {TooltipEl} from 'common/components/tooltip';

import './index.styl';

export enum FormattedPropertyLayout {
  Vertical = `vertical`,
  Horizontal = `horizontal`,
}

const SHOW_TOOLTIP_THRESHOLD = 40;

const MatchParts = ({
  value,
  isEmpty,
  matchParts,
  title,
}: {
  value: string;
  isEmpty: boolean;
  matchParts: string[];
  title?: string;
}) =>
  matchParts ? (
    <>
      {matchParts.map((part) => (
        <span sel='.property-match-part'>{part}</span>
      ))}
    </>
  ) : (
    <div attrs={{title}} class={{'not-set': isEmpty}}>
      {value}
      {value.length > SHOW_TOOLTIP_THRESHOLD && (
        <TooltipEl
          attrs={{
            text: value,
          }}
        />
      )}
    </div>
  );

export function FormattedPropertyMixin({
  property,
  layout,
  matchParts,
}: {
  property: FormattedProperty;
  layout: FormattedPropertyLayout;
  matchParts?: {name: string[]; value: string[]};
}) {
  const {
    name: {formatted: propertyName},
    renderValue,
  } = property;

  // TODO(sam) figure out why typescript won't let me destructure title and href even though renderValue is a union type?
  const {renderString, isEmpty, type, title, href} = renderValue as any;

  const matchName = matchParts?.name;
  const matchValue = matchParts?.value;

  return (
    <div
      sel='.property-wrapper'
      class={{
        [layout]: true,
      }}
    >
      <div sel='.property-name'>
        <MatchParts isEmpty={isEmpty} value={propertyName} matchParts={matchName} />
      </div>
      <div sel='.property-value'>
        {type === PropertyRenderType.String ? (
          <MatchParts isEmpty={isEmpty} value={renderString} matchParts={matchValue} title={title} />
        ) : (
          <a
            attrs={{href, title, target: type === PropertyRenderType.Link ? `_blank` : undefined}}
            on={{click: (ev) => ev.stopPropagation()}}
          >
            <MatchParts isEmpty={isEmpty} value={renderString} matchParts={matchValue} />
          </a>
        )}
      </div>
    </div>
  );
}
